import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { theme } from 'globalStyles'
import { arrayOf, func, number, string } from 'prop-types'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'

export const Controls = ({ images, currentIndex, setCurrentIndex, goToNextItem, goToPrevItem }) => {
  const imageListRef = useRef(null)

  useEffect(() => {
    const index = currentIndex - 2 > 0 ? currentIndex - 2 : 0
    imageListRef.current.scrollTo({ top: imageListRef.current.children[index]?.offsetTop || 0, behavior: 'smooth' })
  }, [currentIndex])

  return (
    <Wrap>
      <Icon icon={faChevronUp} onClick={goToPrevItem} disabled={currentIndex === 0} />
      <ImageList ref={imageListRef}>
        {images.map((image, index) => (
          <Image key={index} src={image} onClick={() => setCurrentIndex(index)} active={index === currentIndex} />
        ))}
      </ImageList>
      <Icon icon={faChevronDown} onClick={goToNextItem} disabled={currentIndex === images.length - 1} />
    </Wrap>
  )
}

Controls.propTypes = {
  images: arrayOf(string).isRequired,
  currentIndex: number.isRequired,
  setCurrentIndex: func.isRequired,
  goToNextItem: func,
  goToPrevItem: func,
}

const ImageList = styled.div`
  width: 75px;
  position: relative;
  max-height: 348px;
  overflow: hidden;
  margin-top: 1rem;
  margin-bottom: 1rem;
`
const Image = styled.img`
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  &:hover {
    opacity: 1;
  }
  transition: 0.4s;
  width: 100%;
  display: block;
  margin-bottom: 0.5rem;
  cursor: pointer;
`

const Wrap = styled.div`
  width: 75x;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-direction: center;
  display: none;

  ${theme.breakpoints.tablet} {
    display: flex;
  }
`
const Icon = styled(FontAwesomeIcon)`
  font-size: 1.25rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`
